// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
    nav: {
      dashboard: "Dashboard",
      management: "Management",
      organizations: "All Organizations",
      sub_organizations: "Sub-organizations",
      sub_organizations_list: "Sub-organizations List",
      staff: "Staff",
      users: "Users",
      operational: "Operational",
      analytics: "System Analytics",
      app_admins: "App Admins",
      products: "Products",
      commands: "Orders",
      categories: "Categories",
      statistics: "Statistics",
      settings: "Settings",
      billing: "Billing",
      parent_organization: "Parent Organization",
      my_sub_organization: "My Sub-Organization",
      branch_settings: "Branch Settings",
      general: "Dashboard",
      parent_staff: "Parent organization staff",
      Pos_config: "POS Configuration",
      create_user: "Create user",
      create_product: "Create product",
      products_from_pos: "Products from POS",
      order_products: "Products",
      sub_org_products_list: "Sub-organization products list",
      sub_org_staff_list: "Sub-organization staff list",
      all_organizations: "All organizations",
      new_organization: "New organization",
      new_sub_organization: "New sub-organization",
      new_category: "New category",
      edit_category: "Edit Category",
      organization: "Organization",
      list: "List",
      childs_organization: "Childs Organization",
      save_changes: "Save changes",
      create_organization: "Create Organization",
      edit_organization: "Edit Organization",
      new_parent_organization: "New Organization",
      cancel: "Cancel",
      back: "Back",
      company_settings: "Company Settings",
      action_logs: "Action Logs",
      upselling: "Upselling",
      overview: "Overview",
      new_badge: "NEW",
      health: {
        system_name: "AI-LYN System",

        all_systems: "All systems are",
        operational: "operational",
        maintenance: "in maintenance",
        system_status: "System status",
        aws_server: "AWS server",
        voice_app: "Voice app",
        online: "Online",
        offline: "Offline",
        pos_connected: "POS connected",
        pos_error: "POS error",
        pos_syncing: "POS syncing…",
        pos_not_configured: "POS not connected",
        pos_unknown: "POS unavailable",
      },
    },
  org: {
    name: "Organization Name",
    monthly_fee: "Monthly Fee ($)",
    order_fee: "Order Fee ($)",
    payment_deadline: "Payment Deadline (days)",
    postal_code: "Postal Code",
    postal_code_ex: "Postal Code (ex: H2W)",
    city: "City",
    province: "Province",
    federal_tax: "Federal Tax (%)",
    provincial_tax: "Provincial Tax (%)",
    info: "Organization Information",
    info_title: "🏢 Organization Information",
    manager_info: "Manager Information",
    manager_info_title: "👤 Manager Information",
    taxes_section: "Taxes (Auto-filled by Postal Code)",
    manager_name: "Manager Name",
    manager_phone: "Manager Phone",
    manager_email: "Manager Email",
    password: "Password",
    description: "Description",
    branches_number: "Number of Branches",
    details: "Organization details",
    sub_details: "Sub organization details",
    create: "Create Organization",
    edit_org: "Edit Organization",
    create_success: "Creation successful!",
    update_success: "Update successful!",
    create_fail: "Creation failed",
    update_fail: "Update failed",
    error: "An error occurred",
    tax_update_info: "Location and tax information updated!",
    agent_first_name: "Agent First Name",
    agent_last_name: "Agent Last Name",
    agent_email: "Agent Email",
    agent_phone: "Agent Phone",
    support_account: "Support Account",
    support_name: "Support Name",
    support_phone: "Support Phone",
    support_email: "Support Email",
    support_password: "Support Password",
  },
  order: {
    list: "Orders",
    total: "Order Total",
    date: "Order Date",
    status: "Status",
    details: "Details",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    delete_title: "Order Deletion",
    delete_confirm: "Are you sure you want to delete this order?",
    delete_multiple: "Are you sure want to delete",
    items: "items?",
    all: "All",
    id: "ID Order",
    waiting: "Waiting",
    accepted: "Accepted",
    unaccepted: "Unaccepted",
    on_the_move: "On the move",
    delivered: "Delivered",
    undelivered: "Undelivered",
    cancelled: "Cancelled",
    pos_entered: "POS Entered",
    in_progress: "In Progress",
    subtotal: "Sub-total",
    tax_fed: "GST",
    tax_prov: "QST",
    items_count: "{{count}} item",
    items_count_plural: "{{count}} items",
    products_count: "{{count}} product",
    products_count_plural: "{{count}} products",
    products_list: "Ordered products",
    qty_short: "Qty",
    price_short: "Price",
    extras: "Extras",
    no_orders: "No orders found",
    no_orders_subtitle: "New orders will appear automatically",
    auto_update: "Automatic update",
    accuracy: "Accuracy",
  },
  organization: {
    listTitle: "Organizations List",
    new: "New organization",
    name: "Name",
    responsibleName: "Responsible Name",
    responsiblePhone: "Responsible Phone",
    address: "Address",
    numberOfBranches: "Number of Branches",
    search_placeholder: "Search (name, city, email...)",
    advanced_filters: "Advanced filters",
    filters: {
      all: "All",
      active: "Active",
      banned: "Banned",
      inactive: "Inactive",
    }
  },
  product: {
    name: "Product",
    price: "Price",
    category: "Category",
    status: "Status",
    search: "Search...",
    clear: "Clear",
  },
  filters: {
    all: "All",
    active: "Active",
    banned: "Banned",
    inactive: "Inactive",
  },
  table: {
    name: "Name",
    manager_name: "Manager Name",
    manager_phone: "Manager Phone",
    manager_email: "Manager Email",
    city: "City",
    status: "Status",
    branches_number: "Branches",
    orders_30d: "AI Orders (30d)",
    performance: "Performance",
    actions: "Actions",
    full_name: "Full Name",
    phone: "Phone",
    email: "Email",
    role: "Role",
    monthly_fee: "Monthly Fee",
    order_fee: "Order Fee",
  },
  actions: {
    Delete: "Delete",
    Edit: "Edit",
    Details: "Details",
    Admin: "Admin",
    Branches: "Branches",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Loading: "Loading...",
    Active: "Active",
    Inactive: "Inactive",
    Close: "Close",
  },
  common: {
    optional: "optional",
  },
  upload: {
    allowed: "Allowed *.jpeg, *.jpg, *.png, *.gif",
    max_size: "max size of",
    title: "Drop or Select file",
    description_before: "Drop files here or click",
    browse: "browse",
    description_after: "through your machine",
    remove_all: "Remove all",
    upload_files: "Upload files",
  },
  status_options: {
    prospecting: "Prospecting",
    interested_in: "Interested In",
    negotiation: "Negotiation",
    confirmed: "Confirmed",
    deployment_in_progress: "Deployment in Progress",
    active: "Active",
    on_hold: "On Hold",
    to_follow_up: "To Follow Up",
    closed: "Closed",
    declined: "Declined",
  },
  dialogs: {
    organization_deletion: "Organization Deletion",
    organization_deletion_confirmation: "Are you sure you want to delete this organization?",
    organization_user_deletion: "User Deletion",
    organization_user_deletion_confirmation: "Are you sure you want to delete this user?",
    sub_organization_deletion: "Sub-organization Deletion",
    confirm_deletion: "Are you sure you want to delete?",
    branch_user_deletion: "Branch User Deletion",
    branch_user_deletion_confirmation: "Are you sure you want to delete this branch user?",
    order_deletion: "Order Deletion",
    order_deletion_confirmation: "Are you sure you want to delete this order?",
    product_deletion: "Product Deletion",
    product_deletion_confirmation: "Are you sure you want to delete this product?",
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  details: `details`,
  personal_information: `Personal Information`,
  created_at: `Created At`,
  updated_at: `Updated At`,
  user_details: `Staff details`,
  api: `API`,
  free: `Free`,
  placeholders: {
    pos_key: "Pos Key...",
    fees: "Fees...",
    monthly: "Monthly...",
    order: "Order...",
    share: "Share what you are thinking here...",
  },
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  auth: {
    invalid_code: "The verification code is invalid. Please check and try again.",
    code_expired: "The verification code has expired. Please request a new one.",
    email_not_found: "No account found with this email address.",
    email_send_failed: "Failed to send email. Please try again later.",
    password_changed: "Password changed successfully!",
    code_resent: "Verification code sent successfully!",
    email_required: "Email is required to resend the code.",
    generic_error: "An unexpected error occurred. Please try again.",
    code_required: "Code is required",
    email_is_required: "Email is required",
    email_valid: "Email must be a valid email address",
    password_required: "Password is required",
    first_name_required: "First name required",
    last_name_required: "Last name required",
    confirm_password_required: "Confirm password is required",
    passwords_must_match: "Passwords must match",
    password_min_length: "Password must be at least 6 characters",
    forgot_password: "Forgot password?",
    login: "Login",
    create_account: "Create account",
    verify: "Verify",
    verify_success: "Verify success!",
    update_password: "Update Password",
    resend_code: "Resend code",
    dont_have_code: "Don't have a code?",
  },
  invoice: {
    title: "Invoices",
    list: "Invoices History",
    status_in_progress: "In Progress",
    status_to_pay: "To Pay",
    status_paid: "Paid",
    status_late: "Late",
    total_orders: "Total Orders",
    total_amount: "Total Amount",
    month: "Month",
    year: "Year",
    download_pdf: "Download PDF",
    pay: "Pay Invoice",
    upload_proof: "Upload Payment Proof",
    upload_proof_required: "Please select a file",
    proof_file: "Proof File",
    payment_type: "Payment Type",
    payment_type_transfer: "Bank Transfer",
    payment_type_check: "Check",
    payment_type_required: "Please select a payment type",
    confirm_payment: "Confirm Payment",
    payment_success: "Payment confirmed — status updated",
    proof_reference_placeholder: "Transfer / check number...",
    payment_date: "Payment Date",
    proof_reference: "Proof Reference",
    id: "Invoice ID",
    no_invoices: "No invoices found",
    all: "All",
    delete_confirmation: "Are you sure you want to delete this invoice?",
    deadline_p7: "P7 - Payment in 7 days",
    deadline_p15: "P15 - Payment in 15 days",
    deadline_p30: "P30 - Payment in 30 days",
    deadline_p45: "P45 - Payment in 45 days",
    deadline_p60: "P60 - Payment in 60 days",
    view_pdf: "Preview",
    preview: "Invoice Preview",
  },
  pos: {
    config_title: "POS Configuration",
    config_description: "Configure here the connection specific to your branch. If no parameters are filled, the parent organization's configuration will be used by default.",
    type: "POS Type",
    sync_with_pos: "Synchronize with POS",
    pull: "Retrieve from POS",
    push: "Send to POS",
    retrieve_from_pos: "Retrieve from POS",
    send_to_pos: "Send to POS",
    save_config: "Save Configuration",
    fill_required_fields: "Please fill all required fields",
    loading_fields: "Loading configuration fields...",
    status: {
      not_configured: "Not Configured",
      configured: "Configured (Ready to Sync)",
      syncing: "Synchronizing...",
      synced: "Synchronized",
      error: "Sync Error",
    },
    save_success: "POS Configuration saved successfully",
    save_error: "Error saving POS configuration",
    sync_success: "Bidirectional sync successful!",
    sync_error: "Error during synchronization",
    pull_success: "Pull from POS successful!",
    pull_error: "Error during pull from POS",
    pull_loading: "Retrieving products from POS...",
    push_success: "Push to POS successful!",
    push_error: "Error during push to POS",
    push_loading: "Sending products to POS...",
    save_loading: "Saving and initial synchronization...",
    not_configured_title: "POS not configured",
    not_configured_content: "You must configure the POS in the branch settings before you can synchronize products.",
  },
  upsell: {
    title: "Upselling",
    description: "Manage addon suggestions, products and intelligent replacements.",
    new_rule: "New rule",
    tabs: {
      overview: "Overview",
      rules: "All Rules",
      addons: "Addons",
      end_order: "End of order",
      analytics: "Analytics",
    },
    kpi: {
      acceptance_rate: "Acceptance rate",
      revenue: "Generated revenue",
      suggestions: "Sent suggestions",
      boost: "Boosted average check",
      vs_previous: "vs previous period",
    },
    chart: {
      title: "Upsell Performance",
      subtitle: "Acceptance Rate vs Generated Revenue",
      "30_days": "Last 30 days",
      "7_days": "Last 7 days",
      export: "Export",
    },
    list: {
      title: "Upselling Rules",
      search: "Search for a rule...",
      empty: "No rules configured.",
      add: "Add a rule",
      all_products: "All products",
      select_help: "Select a rule to see details or click \"New rule\"",
    },
    form: {
      details: "Rule details",
      active: "Active",
      rule_type: "Rule type",
      types: {
        addon: "Addon",
        product: "Suggested product",
        suggested_product: "Suggested product",
        replacement: "Replacement",
        end_order: "End of order",
      },
      trigger: "Trigger",
      trigger_product: "Trigger product",
      suggest: "Suggest",
      suggested_product: "Suggested product",
      custom_phrase_help: "Custom phrase for Gemini (ex: \"Would you like some cheese?\"). If empty, a generic phrase will be used.",
      moment: "Moment",
      conditions: "Conditions (optional)",
      add_condition: "Add",
      time: "Time",
      channel: "Channel",
      priority: "Priority",
      delete: "Delete",
      save: "Save",
    },
    moments: {
      after_add_item: "After item added",
      before_payment: "Before payment",
      end_of_order: "End of order",
      anytime: "Anytime",
    },
    priority: {
      high: "High",
      medium: "Medium",
      low: "Low",
    }
  },
  operational_kpi: {
    page_title: "Operational Dashboard",
    heading: "Operational dashboard",
    subtitle: "Real-time monitoring of AI performance and connected terminals.",
    online: "ONLINE",
    offline: "OFFLINE",
    period: "Period",
    period_24h: "Last 24h",
    period_7d: "Last 7 days",
    period_30d: "Last 30 days",
    branch: "Branch",
    refresh: "Refresh",
    refresh_off: "Off",
    refresh_now: "Refresh",
    section_realtime: "Real time",
    live_data: "Live data",
    section_ai_performance: "AI Performance",
    section_monitoring: "Monitoring & quality",
    ai_health_score: "AI Health Score",
    active_terminals: "Active terminals",
    terminals_online_now_suffix: "online now",
    active_sessions: "Active sessions",
    in_progress: "In progress",
    completed_sessions: "Completed sessions",
    abandoned_sessions_prefix: "Abandoned sessions:",
    clients_served: "Clients served",
    orders_delivered: "Orders delivered",
    ai_requests: "AI requests",
    over_period: "Over period",
    wait_time: "Wait time",
    avg_in_queue: "Avg in queue",
    pickup_time: "Pickup time",
    average: "Average",
    order_duration: "Order duration",
    recognition_success: "Recognition success",
    orders_no_error: "Orders without error",
    prediction_reliability: "Prediction reliability",
    confidence_score: "Confidence score",
    human_interventions: "Human interventions",
    today: "Today",
    repeat_count: "Repeat count",
    alerts_triggered: "Alerts triggered",
    problems_detected: "Problems detected",
    avg_latency: "Average latency",
    p95_latency: "P95 latency",
    orders_per_hour: "Orders per hour",
    hour: "Hour",
    load_per_day: "Load (volume per day)",
    load_per_5min: "Load (volume per 5-min slot)",
    no_recent_load: "No recent load data.",
    total: "Total",
    avg_per_day: "Average / day",
    peak: "Peak",
    realtime_orders: "Realtime orders",
    view_all: "View all",
    col_number: "No.",
    col_state: "State",
    col_time: "Time",
    col_volume: "Volume",
    col_ai: "AI",
    no_recent_orders: "No recent orders in the selected window.",
  },
  analytics_kpi: {
    page_title: "Analytics Dashboard",
    heading: "Analytics KPI",
    subtitle: "Conversion and business trend analytics for AI voice ordering.",
    window: "Window",
    window_24h: "Last 24h",
    window_7d: "Last 7 days",
    window_30d: "Last 30 days",
    branch_scope: "Branch Scope",
    refresh: "Refresh",
    refresh_off: "Off",
    refresh_now: "Refresh now",
    ai_orders_trend: "AI Orders (Trend Sum)",
    completion_rate: "Completion Rate",
    avg_latency_trend: "Average Latency (Trend)",
    alerts_trend: "Alerts (Trend Sum)",
    drop_off_rate: "Drop-off Rate",
    human_takeover_rate: "Human Takeover Rate",
    daily_trends: "Daily Trends",
    daily_trends_sub: "Orders, conversion and drop-off over time",
    col_day: "Day",
    col_ai_orders: "AI Orders",
    col_avg_latency: "Avg Latency",
    col_alerts: "Alerts",
    no_data: "No trend data for selected range.",
  },
  action_logs: {
    page_title: "Activity Log",
    heading: "Activity Log",
    breadcrumb_logs: "Logs",
    filter_action_type: "Action Type",
    filter_entity: "Entity (e.g. Organization)",
    filter_all: "All",
    col_date: "Date",
    col_user: "User",
    col_action: "Action",
    col_entity: "Entity",
    col_organization: "Organization",
    col_description: "Description",
    col_ip: "IP",
    col_actions: "Actions",
    detail_title: "Action Log Details",
    detail_user: "User",
    detail_email: "Email",
    detail_role: "Role",
    detail_action: "Action",
    detail_entity: "Entity",
    detail_entity_id: "Entity ID",
    detail_description: "Description",
    detail_details: "Details (JSON)",
    detail_ip: "IP Address",
    detail_organization: "Organization",
    detail_date: "Date",
    delete_title: "Delete Log",
    delete_confirm: "Are you sure you want to delete this action log?",
    no_details: "No additional details",
    no_organization: "N/A",
    delete_success: "Action log deleted successfully",
    delete_error: "Error deleting action log",
  },
  pages: {
    users_management: "Global User Management",
    all_users_list: "List of all users",
    user_cards: "User Cards",
    account: "Account",
    account_settings: "Account Settings",
    edit_staff: "Edit Staff",
    edit_product: "Edit Product",
    org_product_details: "Organization's Product Details",
    create_product: "Create New Product",
    permission_denied: "Permission Denied",
    parent_org_profile: "Parent Organization Profile",
    sub_organizations: "Sub-organizations",
    edit_sub_org: "Edit Sub-organization",
    sub_org_profile: "Sub-organization Profile",
    create_sub_org: "Create a Sub-organization",
    parent_organization: "Parent Organization",
    create_order: "Create a New Order",
    order_details: "Order Details",
    kanban: "Kanban",
    edit_invoice: "Edit Invoice",
    invoice_details: "Invoice Details",
    create_invoice: "Create a New Invoice",
    file_manager: "File Manager",
    shop: "Shop",
    product_details: "Product Details",
    checkout: "Checkout",
    calendar: "Calendar",
    post_details: "Post Details",
    blog: "Blog",
    create_post: "Create a New Post",
  },
};

export default en;